import apiClient from './apiClient'
import { buildApiUrl } from '../utils/getConfiguration'

export const updateReminderState = async ({ reminderId, state, accountId }) => {
  if (!reminderId || !state || !accountId) {
    throw new Error('Missing parameters for updateReminderState')
  }

  const response = await apiClient.get(
    buildApiUrl('remindersStatusUpdate', {
      reminder_ID: reminderId,
      state,
      account_ID: accountId,
    }),
  )
  return response.data
}

export const postponeReminder = async ({ reminderId, expecteddate, accountId }) => {
  if (!reminderId || !accountId) {
    throw new Error('Missing parameters for postponeReminder')
  }

  const params = {
    reminder_ID: reminderId,
    account_ID: accountId,
  }

  if (expecteddate !== undefined && expecteddate !== null && expecteddate !== '') {
    params.expecteddate = expecteddate
  }

  const response = await apiClient.get(buildApiUrl('remindersDueDateUpdate', params))
  return response.data
}

const remindersService = {
  updateReminderState,
  postponeReminder,
}

export default remindersService
